// eslint-disable-next-line max-params
export default (key, value, expiryDays = 1, domain = "") => {
    const expiryDate = new Date();
    const SECONDS = 60;
    const HOURS = 24;
    const MILLISECONDS = 1000;
    expiryDate.setTime(
        expiryDate.getTime() + (expiryDays * HOURS * SECONDS * SECONDS * MILLISECONDS)
    );
    const domainPart = domain ? `;domain=${domain}` : "";
    document.cookie = `${key}=${value};path=/;expires=${expiryDate.toUTCString()}${domainPart}`;
};

const saveSessionCookie = (key, value) => {
    document.cookie = `${key}=${value};path=/;`;
};

export { saveSessionCookie };
